Ext.define('SA.data.BusinessesQuery', {
    alias: 'query.businesses',
    extend: 'SA.data.LocationsQuery',

    createParams() {
        var params = this.callParent();

        params.data = SA.data.BusinessSearches.mapQueryFields(this.country, params.data);

        return params;
    }
});